import './AddAddress.scss';
import { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  StandaloneSearchBox,
} from '@react-google-maps/api';
import gmapStyle from '../../gmapStyle.json';
import Geocode from 'react-geocode';
import { modify } from '../../../../../helpers/ShippingAddress';
import {
  Col,
  Row,
  FormGroup,
  Label,
  Button,
  CardHeader,
  CardBody,
  CardFooter,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { setShippingAddress, setEmailToGuestCart } from '../../actions/action';
import { SuccessToast, ErrorToast } from '../../../../../utils/Toaster';
import toast, { Toaster } from 'react-hot-toast';
import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from 'availity-reactstrap-validation';
import { lowerCase } from 'lodash';
import { Card } from 'react-bootstrap';
import { extractUniqueAddressComponents } from '../../../../../utils/Common';
import { updateCustomerAddress } from '../../../../ServiceOrders/ManageServiceOrders/actions/action';
const center = {
  ae: {
    lat: 25.1675739,
    lng: 55.2614555,
  },
  qa: {
    lat: 25.2842534,
    lng: 51.3719073,
  },
  om: {
    lat: 23.5880307,
    lng: 58.3828717,
  },
  kw: {
    lat: 29.3760606,
    lng: 47.9468472,
  },
  bh: {
    lat: 26.2213902,
    lng: 50.5848642,
  },
};

const contryBounds = {
  ae: {
    north: 26.427929393569457,
    south: 22.427935149720497,
    west: 49.88720042141598,
    east: 57.8381892803542,
  },
  qa: {
    north: 26.2171,
    south: 24.471118,
    west: 50.7211001,
    east: 51.7144001,
  },
  om: {
    north: 28.808004285620157,
    south: 12.427888171440916,
    west: 38.38409066937567,
    east: 70.18813730023504,
  },
  kw: {
    north: 33.15088596365788,
    south: 25.497326905942987,
    west: 39.665945329232116,
    east: 55.5679686446618,
  },
  bh: {
    north: 26.653167758085463,
    south: 25.667091017781722,
    west: 49.63994697023152,
    east: 51.627694184966074,
  },
};
const libraries = ['drawing', 'places', 'marker'];

function AddAddressComponent(props) {
  const {
    setAddress,
    showmapandAddress,
    setShowmapandAddress,
    setShowcart,
    setShowOrderingMode,
    setShowpromotion,
    setShowAssembly,
    setShowCustomerDetails,
    setShowPaymentMethod,
    setShowDeliverySlotSelection,
    setShowInvoiceBreakup,
    setShowComment,
    setShowSalesPersonInfo,
    source = '',
    service_order_no = null,
    closeUpdateLocation = () => {},
    hideSubmit = false,
    formRef = null,
    initialData = null,
  } = props || {};

  const [country, setCountry] = useState(
    lowerCase(
      props.country ||
        localStorage.getItem('currentCountry') ||
        localStorage.getItem('WEBSITE_COUNTRY') ||
        'ae'
    )
  );
  const [selectedLatLng, setSelectedLatLng] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [selectedAddressErrorMsg, setSelectedAddressErrorMsg] = useState(null);
  const [selectedPlusCode, setSelectedPlusCode] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedAddress1, setSelectedAddress1] = useState(null);
  const [selectedAddress2, setSelectedAddress2] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState(country);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [isEnableMap, setIsEnableMap] = useState(true);
  const [isAddressEdit, setIsAddressEdit] = useState(false);
  const [phoneError, setPhoneError] = useState(null);
  const [alternatephoneError, setAlternatephoneError] = useState(null);
  const [selectedAddressError, setSelectedAddressError] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [showCompanyInfo, setShowCompanyInfo] = useState(false);
  const [showAdditionalDeliveryInfo, setShowAdditionalDeliveryInfo] =
    useState(false);
  const [isUpdatingLocation, setIsUpdatingLocation] = useState(false);

  const dispatch = useDispatch();
  const [addressData, setAddressData] = useState({
    firstname: '',
    lastname: '',
    fulladdress: '',
    fulladdress1: '',
    fulladdress2: '',
    email: '',
    mobile: '',
    companyName: '',
    flatNo: '',
    trn: '',
    trnNo: '',
    alteratemobile: '',
    isusedbillingaddress: false,
    isLiftAvailable: true,
    isStaircaseAvailable: true,
    isDeliveryTimeRestriction: false,
    isPermitRequired: false,
    otherInstructions: '',
    deliveryTimeSlot: '',
  });
  const searchBox = useRef(null);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyDbpGEtOjH0Udl-dMEHPYuIl7gXItfWuKU',
    libraries: libraries,
  });
  const google = window.google;
  Geocode.setApiKey('AIzaSyDbpGEtOjH0Udl-dMEHPYuIl7gXItfWuKU');
  const onLoad = useCallback(function callback(map) {}, []);

  const onUnmount = useCallback(function callback(map) {}, []);

  // Optimized: Single Geocode call handler
  const handleGeocodeAndExtract = (lat, lng) => {
    Geocode.fromLatLng(lat, lng).then(
      (response) => {
        // Set plus code and formatted address
        setSelectedPlusCode(response?.plus_code);
        setSelectedAddress(response?.results?.[0]?.formatted_address);
        setSearchValue(response?.results?.[0]?.formatted_address);

        // Extract unique address components (with English preference)
        const uniqueComponents = extractUniqueAddressComponents(
          response?.results || [],
        );
        console.log('uniqueComponents:', uniqueComponents);
        // Collect both neighborhood and sublocality_level_1 long_names
        let neighborhood = null;
        let sublocalityLevel1 = null;
        uniqueComponents.forEach((component) => {
          if (component.types.includes('country')) {
            setSelectedCountry(component.long_name);
            setSelectedCountryCode(component.short_name);
          }
          if (
            component.types.includes('sublocality') ||
            component.types.includes('locality') ||
            component.types.includes('administrative_area_level_1')
          ) {
            setSelectedCity(component.long_name);
          }
          if (
            component.types.includes('locality') ||
            component.types.includes('administrative_area_level_1')
          ) {
            setSelectedRegion(component.long_name);
          }
          if (component.types.includes('neighborhood')) {
            neighborhood = component.long_name;
          }
          if (component.types.includes('sublocality_level_1')) {
            sublocalityLevel1 = component.long_name;
          }
          if (component.types.includes('route')) {
            setSelectedAddress2(component.long_name);
          }
        });
        let address1Parts = [];
        if (neighborhood && sublocalityLevel1) {
          if (neighborhood !== sublocalityLevel1) {
            address1Parts.push(neighborhood, sublocalityLevel1);
          } else {
            address1Parts.push(neighborhood);
          }
        } else if (neighborhood) {
          address1Parts.push(neighborhood);
        } else if (sublocalityLevel1) {
          address1Parts.push(sublocalityLevel1);
        }
        if (address1Parts.length > 0) {
          setSelectedAddress1(address1Parts.join(', '));
        } else {
          setSelectedAddress1(response?.results?.[0]?.formatted_address);
        }

        // Notify parent of location extraction
        setAddress?.({
          ...addressData,
          buildingName: addressData.buildingName,
          streetName: neighborhood || sublocalityLevel1 || response?.results?.[0]?.formatted_address,
          areaName: sublocalityLevel1 || neighborhood || '',
          latitude: lat,
          longitude: lng,
          region: neighborhood || sublocalityLevel1 || '',
          city: sublocalityLevel1 || neighborhood || '',
        });
      },
      (error) => {
        console.error(error);
      },
    );
  };

  const onMapClick = (...args) => {
    const lat = args?.[0]?.latLng?.lat();
    const lng = args?.[0]?.latLng?.lng();
    setSelectedLatLng({ lat, lng });
    setSelectedAddressErrorMsg(null);
    handleGeocodeAndExtract(lat, lng);
  };

  const onLoadSearchBox = (ref) => {
    searchBox.current = ref;
  };

  const onPlacesChanged = () => {
    const places = searchBox.current.getPlaces();
    if (!places) return;
    places.forEach((item) => {
      const lat = item?.geometry?.location?.lat();
      const lng = item?.geometry?.location?.lng();
      if (lat && lng) {
        setSelectedLatLng({ lat, lng });
        handleGeocodeAndExtract(lat, lng);
      }
      // Optionally update plus code and address if available
      if (item?.plus_code) {
        setSelectedPlusCode(item?.plus_code);
      }
      if (item?.formatted_address) {
        setSelectedAddress(item?.formatted_address);
        setSearchValue(item?.formatted_address);
      }
    });
  };

  useEffect(() => {
    if (source !== 'serviceOrder') {
      const savedAddress = JSON.parse(localStorage.getItem('guest_address'));
      if (savedAddress) {
        setAddressData({
          firstname: savedAddress.firstname,
          lastname: savedAddress.lastname,
          fulladdress1: savedAddress.fulladdress1,
          fulladdress2: savedAddress.fulladdress2,
          flatNo: savedAddress?.flatNo,
          email: savedAddress.email,
          mobile: savedAddress.mobile,
          streetName: savedAddress?.streetName,
          buildingName: savedAddress?.buildingName,
          floorNumber: savedAddress?.floorNumber,
          areaName: savedAddress?.areaName,
          nearestLandMark: savedAddress?.nearestLandMark,
          companyName: savedAddress.companyName,
          trn: savedAddress.trn,
          alternateTelephone: savedAddress?.alternateTelephone,
          isAdditionalDeliveryInfo: savedAddress.isAdditionalDeliveryInfo,
          isLiftAvailable:
            savedAddress?.additionalDeliveryData?.isLiftAvailable || true,
          isStaircaseAvailable:
            savedAddress?.additionalDeliveryData?.isStaircaseAvailable || true, // Updated
          isDeliveryTimeRestriction:
            savedAddress?.additionalDeliveryData?.isDeliveryTimeRestriction ||
            false, // Updated
          isPermitRequired:
            savedAddress?.additionalDeliveryData?.isPermitRequired || false,
          otherInstructions:
            savedAddress?.additionalDeliveryData?.otherInstructions || '',
          deliveryTimeSlot:
            savedAddress?.additionalDeliveryData?.deliveryTimeSlot || '',
        });
        setShowCompanyInfo(savedAddress.isUsedBilling);
        setIsAddressEdit(true);
        setIsEnableMap(false);
        // getFormattedAddressAndCode(savedAddress.latitude, savedAddress.longitude);
        setAddress?.(savedAddress);
      }
    }
  }, [source]);

  useEffect(() => {
    if (initialData) {
      setAddressData(prev => ({
        ...prev,
        ...initialData
      }));
      if (initialData.latitude && initialData.longitude) {
        const lat = parseFloat(initialData.latitude);
        const lng = parseFloat(initialData.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          setSelectedLatLng({ lat, lng });
          setIsEnableMap(false);
          setIsAddressEdit(true);
        }
      }
    }
  }, [initialData]);

  useEffect(() => {
    if (props.country) {
      setCountry(lowerCase(props.country));
    }
  }, [props.country]);

  const validateDataFromMap = async () => {
    if (selectedCountryCode) {
      if (selectedCountryCode?.toLowerCase() === country) {
        setSelectedAddressError(false);
        setSelectedAddressErrorMsg(null);
        setIsEnableMap(false);
        setIsAddressEdit(true);
      } else {
        setSelectedAddressError(true);
        setSelectedAddressErrorMsg('choose Location Inside Country');
      }
    } else {
      setSelectedAddressError(true);
      setSelectedAddressErrorMsg('Please select location');
    }
  };

  const PhoneNumberHandle = (e, fieldName) => {
    let phLength = e.target.value.length;
    if (phLength >= 7) {
      setIsValid(true);
      setAlternatephoneError(null);
      setPhoneError(null);
      let message = 'Please use valid phone No. without country code';
      if (selectedCountryCode === 'AE') {
        var pattern = new RegExp(
          /^(?:50|51|52|54|55|56|57|58|59|2|3|4|6|7|9)\d{7}$/,
        );
        if (!pattern.test(e.target.value)) {
          setIsValid(false);
          if (fieldName === 'phone') {
            setPhoneError(message);
          } else {
            setAlternatephoneError(message);
          }
        }
      } else if (selectedCountryCode === 'BH') {
        pattern = new RegExp(
          /^(?:\+973|00973|0)?(?:30|31|32|33|34|35|36|37|38|39|60|61|62|63|64|65|66|67|68|69)\d{6}$/,
        );
        if (!pattern.test(e.target.value)) {
          setIsValid(false);
          if (fieldName === 'phone') {
            setPhoneError(message);
          } else {
            setAlternatephoneError(message);
          }
        }
      } else if (selectedCountryCode === 'OM') {
        pattern = new RegExp(
          /^(?:\+968|00968|0)?(?:71|72|73|74|75|76|77|78|79|91|92|93|94|95|96|97|98|99)\d{6}$/,
        );
        if (!pattern.test(e.target.value)) {
          setIsValid(false);
          if (fieldName === 'phone') {
            setPhoneError(message);
          } else {
            setAlternatephoneError(message);
          }
        }
      } else if (selectedCountryCode === 'KW') {
        pattern = new RegExp(
          /^(?:\+965|00965|0)?(?:21|22|23|24|25|26|27|28|29|41|42|43|44|45|46|47|48|49|50|51|52|53|54|55|56|57|58|59|60|61|62|63|64|65|66|67|68|69|90|91|92|93|94|95|96|97|98|99)\d{6}$/,
        );
        if (!pattern.test(e.target.value)) {
          setIsValid(false);
          if (fieldName === 'phone') {
            setPhoneError(message);
          } else {
            setAlternatephoneError(message);
          }
        }
      } else {
        pattern = new RegExp(
          /^(?:\+974|00974|0)?(?:30|31|32|33|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|49|50|51|52|53|54|55|56|57|58|59|60|61|62|63|64|65|66|67|68|69|70|71|72|73|74|75|76|77|78|79)\d{6}$/,
        );
        if (!pattern.test(e.target.value)) {
          setIsValid(false);
          if (fieldName === 'phone') {
            setPhoneError(message);
          } else {
            setAlternatephoneError(message);
          }
        }
      }
    } else {
      setIsValid(false);
      if (fieldName === 'phone') {
        setPhoneError('Mobile number min 7 digits');
      } else {
        setAlternatephoneError('Mobile number min 7 digits');
      }
    }
  };

  const handleSubmitSaveAddress = async (event, values) => {
    event?.preventDefault();
    // Ensure additional fields are included in the values object
    const updatedValues = {
      ...values,
      isLiftAvailable: addressData.isLiftAvailable,
      isStaircaseAvailable: addressData.isStaircaseAvailable,
      isDeliveryTimeRestriction: addressData.isDeliveryTimeRestriction,
      isPermitRequired: addressData.isPermitRequired,
    };
    // console.log('values-input', values);
    if (isValid) {
      const saveAddress = {
        _id: 'guest',
        firstname: updatedValues.firstname,
        lastname: updatedValues.lastname,
        fulladdress1: selectedAddress1,
        fulladdress2: selectedAddress2,
        email: updatedValues.email,
        mobile: updatedValues.mobile,
        alternateTelephone: updatedValues?.alternateTelephone,
        countryCode: selectedCountryCode,
        city: selectedCity,
        country: selectedCountry,
        region: selectedRegion,
        mapData: selectedAddress,
        latitude: `${selectedLatLng?.lat}`,
        longitude: `${selectedLatLng?.lng}`,
        addressType: 'Home',
        isDefault: true,
        plusCode:
          selectedPlusCode?.compound_code || selectedPlusCode?.global_code,
        flatNo: updatedValues?.flatNo,
        companyName: updatedValues?.companyName,
        trn: updatedValues?.trn,
        isUsedBilling: showCompanyInfo,
        isAdditionalDeliveryInfo: showAdditionalDeliveryInfo,
        streetName: updatedValues?.streetName,
        buildingName: updatedValues?.buildingName,
        floorNumber: updatedValues?.floorNumber,
        areaName: updatedValues?.areaName,
        nearestLandMark: updatedValues?.nearestLandMark,
        additionalDeliveryData: {
          isLiftAvailabile: updatedValues?.isLiftAvailable ?? true,
          isStaircaseAvailable: updatedValues?.isStaircaseAvailable ?? true,
          isDeliveryTimeRestriction:
            updatedValues?.isDeliveryTimeRestriction ?? false,
          deliveryTimeSlot: updatedValues?.deliveryTimeSlot ?? '',
          isPermitRequired: updatedValues?.isPermitRequired ?? false,
          permitRequiredComment: updatedValues?.permitRequiredComment ?? '',
          otherInstructions: updatedValues?.otherInstructions ?? '',
        },
      };
      setAddress?.(saveAddress);
      setAddressData(saveAddress);
      localStorage.setItem('guest_address', JSON.stringify(saveAddress));
      setShowmapandAddress(false);
      setShowcart(true);
      setShowOrderingMode(true);
      setShowpromotion(true);
      setShowAssembly(true);
      setShowCustomerDetails(true);
      setShowPaymentMethod(true);
      setShowDeliverySlotSelection(true);
      setShowInvoiceBreakup(true);
      setShowComment(true);
      setShowSalesPersonInfo(true);

      const modifiedAddress = await modify(saveAddress);
      const ShippingAddressUpdated = await setShippingAddress(
        { address: modifiedAddress },
        dispatch,
      );
      if (ShippingAddressUpdated) {
        const setEmail = setEmailToGuestCart(updatedValues.email, dispatch);
        SuccessToast('Address Updated');
      } else {
        ErrorToast('Address update error');
      }
    }
  };

  const selectCompanyInfoForBilling = (e) => {
    setShowCompanyInfo(e.target.checked);
  };

  const selectAdditionalDeliveryInfo = (e) => {
    setShowAdditionalDeliveryInfo(e.target.checked);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedAddress = {
      ...addressData,
      [name]: type === 'checkbox' ? checked : value,
    };
    setAddressData(updatedAddress);
    // Explicitly notify parent of changes
    setAddress?.({
      ...updatedAddress,
      latitude: selectedLatLng?.lat,
      longitude: selectedLatLng?.lng,
      region: selectedRegion,
      city: selectedCity
    });
  };

  const handleSubmitServiceOrderAddress = async (event, values) => {
    setIsUpdatingLocation(true);
    event?.preventDefault();
     const updatedValues = {
      ...values
    };
    if (isValid) {
      const addressObj = {
        "service_no": service_order_no,
        "flatNo": updatedValues?.flatNo,
        "buildingName": updatedValues?.buildingName,
        "floorNumber": updatedValues?.floorNumber,
        "streetName": updatedValues?.streetName,
        "areaName": updatedValues?.areaName,
        "nearestLandMark": updatedValues?.nearestLandMark,
        "companyName": updatedValues?.companyName,
        "trnNo": updatedValues?.trnNo,
        "latitude": selectedLatLng?.lat,
        "longitude": selectedLatLng?.lng,
        "mapData": selectedAddress,
        "region": selectedRegion,
        "city": selectedCity
      };

      // console.log('service order address submitted:', addressObj);
      // You can handle address save here
      setAddress?.(addressObj);
      if (service_order_no) {
        const result = await updateCustomerAddress({ addressObj });
        if (result && result.code === 100) {
          SuccessToast('Service Order Address Updated Successfully');
          closeUpdateLocation();
          setIsUpdatingLocation(false);
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          ErrorToast('Failed to Update Service Order Address');
          setIsUpdatingLocation(false);
        }
      } else {
        setIsUpdatingLocation(false);
      }
    }
  };
        

  return (
    <>
      {showmapandAddress ? (
        <>
          <Card>
            <CardHeader className="bg-light">
              <h6>{source === 'serviceOrder' ? 'Fill Customer Address' : 'Fill Customer Shipping Address'}</h6>
            </CardHeader>
            <CardBody>
              <Row>
                <Col>
                  {isEnableMap && (
                    <div className="addNewLocationMap">
                      <div className="addNewLocationGoogleMap position-relative">
                        <div className="LocationGoogleMap">
                          {isLoaded && country && contryBounds[country] && (
                            <div className="addNewLocationGoogleMap">
                              <span
                                className="close"
                                onClick={() => {
                                  setSearchValue('');
                                }}
                                style={{ top: 8, right: 8 }}
                              ></span>

                              <GoogleMap
                                mapContainerStyle={{
                                  width: '100%',
                                  height: '500px',
                                }}
                                zoom={13}
                                onLoad={onLoad}
                                onUnmount={onUnmount}
                                styles={gmapStyle}
                                options={{
                                  styles: gmapStyle,
                                  draggable: true,
                                  streetViewControl: false,
                                  fullscreenControl: false,
                                  mapTypeControl: false,

                                  restriction: {
                                    latLngBounds: contryBounds[country],
                                    strictBounds: true,
                                  },
                                }}
                                center={selectedLatLng || center?.[country]}
                                onClick={onMapClick}
                              >
                                <>
                                  <Marker
                                    position={selectedLatLng}
                                    icon={{
                                      url: 'https://assets.danubehome.com/media/email/dhMapMarker.svg',
                                      anchor: new google.maps.Point(17, 46),
                                      scaledSize: new google.maps.Size(37, 37),
                                    }}
                                    animation="DROP"
                                  />

                                  <StandaloneSearchBox
                                    onPlacesChanged={onPlacesChanged}
                                    onLoad={onLoadSearchBox}
                                    bounds={contryBounds[country]}
                                  >
                                    <>
                                      <input
                                        type="text"
                                        className="inputStyle"
                                        value={searchValue}
                                        onChange={(event) => {
                                          setSearchValue(event?.target?.value);
                                        }}
                                      />
                                    </>
                                  </StandaloneSearchBox>
                                </>
                              </GoogleMap>
                            </div>
                          )}
                        </div>
                      </div>
                      {selectedAddressError ? (
                        <div className="text-danger d-flex justify-content-end">
                          {selectedAddressErrorMsg}
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="mapErrorSaveContainer">
                        <div
                          className="d-flex justify-content-end buttonContainSave"
                          onClick={() => {
                            validateDataFromMap();
                          }}
                        >
                          <Button
                            color="success"
                            type="submit"
                            className="mt-3"
                          >
                            Update & Continue
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>

              {isAddressEdit && (
                <Row>
                  <Col md={6}>
                    <div className="position-relative rounded overflow-hidden h-100">
                      <div
                        className="d-flex justify-content-between align-items-center position-absolute bg-light px-2 py-2 w-100"
                        style={{ zIndex: 9 }}
                      >
                        <div className="fs-12 fw-medium text-dark">
                          {selectedAddress}
                        </div>
                        <Button
                          outline
                          color="dark"
                          className="fs-11 px-2 py-1"
                          onClick={() => {
                            setIsEnableMap(true);
                            setIsAddressEdit(false);
                          }}
                        >
                          Change
                        </Button>
                      </div>
                      {isLoaded && (
                        <GoogleMap
                          mapContainerStyle={{
                            minHeight: 250,
                            width: '100%',
                            height: '90%',
                          }}
                          className="gMap h-100"
                          center={selectedLatLng}
                          zoom={15}
                          onLoad={onLoad}
                          onUnmount={onUnmount}
                          styles={gmapStyle}
                          icon={{
                            url: 'https://assets.danubehome.com/media/email/dhMapMarker.svg',
                            anchor: new google.maps.Point(17, 46),
                            scaledSize: new google.maps.Size(37, 37),
                          }}
                          animation="DROP"
                          options={{
                            styles: gmapStyle,
                            draggable: false,
                            streetViewControl: false,
                            fullscreenControl: false,
                          }}
                        >
                          <>
                            <Marker position={selectedLatLng} />
                          </>
                        </GoogleMap>
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="addNewAddressForm">
                      <AvForm 
                        ref={formRef}
                        onValidSubmit={source === 'serviceOrder' ? handleSubmitServiceOrderAddress : handleSubmitSaveAddress}
                      >
                        {source !== 'serviceOrder' && (
                          <>
                            <Row>
                              <Col>
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom04" className="fs-12">First Name</Label>
                                  <AvField
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: 'Please Fill First name.',
                                      },
                                    }}
                                    name="firstname"
                                    type="text"
                                    value={addressData.firstname}
                                  />
                                </FormGroup>
                              </Col>
                              <Col>
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom04" className="fs-12">Last Name</Label>
                                  <AvField
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: 'Please Fill Last name.',
                                      },
                                    }}
                                    name="lastname"
                                    type="text"
                                    value={addressData.lastname}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom04" className="fs-12">Email</Label>
                                  <AvField
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: 'Please Fill Valid email.',
                                      },
                                    }}
                                    name="email"
                                    type="email"
                                    value={addressData.email}
                                  />
                                </FormGroup>
                              </Col>
                              <Col>
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom04" className="fs-12">Mobile Number</Label>
                                  <AvField
                                    name="mobile"
                                    type="text"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: 'Please Fill valid mobile number .',
                                      },
                                    }}
                                    value={addressData.mobile}
                                    onChange={(e) => PhoneNumberHandle(e, 'phone')}
                                  />
                                  <span className="text-danger">{phoneError}</span>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup className="mb-3">
                                  <Label htmlFor="validationCustom04" className="fs-12">Alternate Phone</Label>
                                  <AvField
                                    name="alternateTelephone"
                                    type="text"
                                    value={addressData.alternateTelephone}
                                    onChange={(e) => PhoneNumberHandle(e, 'alternatephone')}
                                  />
                                  <span className="text-danger">{alternatephoneError}</span>
                                </FormGroup>
                              </Col>
                            </Row>
                          </>
                        )}
                        {/* Apartment/Building Name always visible */}
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom04" className="fs-12">Apartment/Building Name {source === 'serviceOrder' && <span className="text-danger">*</span>}</Label>
                              <AvField
                                name="buildingName"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: 'Please Fill building name .',
                                  },
                                }}
                                type="text"
                                placeholder="e.g Apartment 4,Danube HO"
                                className="form-control"
                                value={addressData.buildingName}
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="streetName" className="fs-12">
                                Street Name {source === 'serviceOrder' && <span className="text-danger">*</span>}
                              </Label>
                              <AvField
                                name="streetName"
                                type="text"
                                validate={{
                                  required: {
                                    value: source === 'serviceOrder',
                                    errorMessage: 'Please Fill street name',
                                  },
                                }}
                                placeholder="Enter Street Name"
                                value={addressData.streetName}
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="flatNo" className="fs-12">
                                Flat No {source === 'serviceOrder' && <span className="text-danger">*</span>}
                              </Label>
                              <AvField
                                name="flatNo"
                                type="text"
                                validate={{
                                  required: {
                                    value: source === 'serviceOrder',
                                    errorMessage: 'Please Fill flat no',
                                  },
                                }}
                                placeholder="Enter Flat No"
                                value={addressData.flatNo}
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="floorNumber" className="fs-12">
                                Floor Number {source === 'serviceOrder' && <span className="text-danger">*</span>}
                              </Label>
                              <AvField
                                name="floorNumber"
                                type="text"
                                validate={{
                                  required: {
                                    value: source === 'serviceOrder',
                                    errorMessage: 'Please Fill floor number',
                                  },
                                }}
                                placeholder="Enter Floor Number"
                                value={addressData.floorNumber}
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="areaName" className="fs-12">
                                Area Name {source === 'serviceOrder' && <span className="text-danger">*</span>}
                              </Label>
                              <AvField
                                name="areaName"
                                type="text"
                                validate={{
                                  required: {
                                    value: source === 'serviceOrder',
                                    errorMessage: 'Please Fill area name',
                                  },
                                }}
                                placeholder="Enter Area Name"
                                value={addressData.areaName}
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label
                                htmlFor="nearestLandMark"
                                className="fs-12"
                              >
                                Nearest Landmark {source === 'serviceOrder' && <span className="text-danger">*</span>}
                              </Label>
                              <AvField
                                name="nearestLandMark"
                                type="text"
                                validate={{
                                  required: {
                                    value: source === 'serviceOrder',
                                    errorMessage: 'Please Fill nearest landmark',
                                  },
                                }}
                                placeholder="Enter Nearest Landmark"
                                value={addressData.nearestLandMark}
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        {source === 'serviceOrder' && (
                          <>
                            <Row>
                              <Col>
                                <h6 className="fs-13 fw-medium mt-2 mb-2">Company Info</h6>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup className="mb-3">
                                  <Label htmlFor="companyName" className="fs-12">Company Name</Label>
                                  <AvField
                                    name="companyName"
                                    type="text"
                                    placeholder="Enter Company Name"
                                    className="form-control"
                                    value={addressData.companyName}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                              <Col>
                                <FormGroup className="mb-3">
                                  <Label htmlFor="trnNo" className="fs-12">TRN No.</Label>
                                  <AvField
                                    name="trnNo"
                                    type="text"
                                    placeholder="Enter TRN No"
                                    className="form-control"
                                    value={addressData.trnNo}
                                    onChange={handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </>
                        )}

                        {source !== 'serviceOrder' && (
                          <>
                            <Row>
                              <Col>
                                <FormGroup className="mb-3">
                                  <AvCheckboxGroup name="isusedbillingaddress">
                                    <AvCheckbox
                                      label="Company info for Billing"
                                      checked={showCompanyInfo}
                                      onChange={selectCompanyInfoForBilling}
                                    />
                                  </AvCheckboxGroup>
                                </FormGroup>
                              </Col>
                            </Row>
                            {showCompanyInfo ? (
                              <Row>
                                <Col>
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom04" className="fs-12">Company name</Label>
                                    <AvField
                                      name="companyName"
                                      type="text"
                                      value={addressData.companyName}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom04" className="fs-12">TRN No.</Label>
                                    <AvField
                                      name="trn"
                                      type="text"
                                      value={addressData.trn}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            ) : ('')}
                            <Row>
                              <Col>
                                <FormGroup className="mb-3">
                                  <AvCheckboxGroup name="isusedbillingaddress">
                                    <AvCheckbox
                                      label="Additional delivery information"
                                      checked={showAdditionalDeliveryInfo}
                                      onChange={selectAdditionalDeliveryInfo}
                                    />
                                  </AvCheckboxGroup>
                                </FormGroup>
                              </Col>
                            </Row>
                          </>
                        )}

                        {showAdditionalDeliveryInfo && (
                          <>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <Label
                                      htmlFor="isLiftAvailable"
                                      className="fs-12 mb-0 me-2"
                                    >
                                      Confirm the availability of Lift in your
                                      premise?
                                    </Label>
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="fs-12">No</span>
                                      <div className="form-check form-switch m-0">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="isLiftAvailable"
                                          name="isLiftAvailable"
                                          checked={addressData.isLiftAvailable}
                                          onChange={(e) => {
                                            const { name, checked } = e.target;
                                            setAddressData((prevData) => ({
                                              ...prevData,
                                              [name]: checked,
                                            }));
                                          }}
                                        />
                                      </div>
                                      <span className="fs-12">Yes</span>
                                    </div>
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <Label
                                      htmlFor="isStaircaseAvailable"
                                      className="fs-12 mb-0 me-2"
                                    >
                                      Confirm the availability of Staircase in
                                      your premise?
                                    </Label>
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="fs-12">No</span>
                                      <div className="form-check form-switch m-0">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="isStaircaseAvailable"
                                          name="isStaircaseAvailable"
                                          checked={
                                            addressData.isStaircaseAvailable
                                          }
                                          onChange={(e) => {
                                            const { name, checked } = e.target;
                                            setAddressData((prevData) => ({
                                              ...prevData,
                                              [name]: checked,
                                            }));
                                          }}
                                        />
                                      </div>
                                      <span className="fs-12">Yes</span>
                                    </div>
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <Label
                                      htmlFor="isDeliveryTimeRestriction"
                                      className="fs-12 mb-0 me-2"
                                    >
                                      Delivery time restrictions?
                                    </Label>
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="fs-12">No</span>
                                      <div className="form-check form-switch m-0">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="isDeliveryTimeRestriction"
                                          name="isDeliveryTimeRestriction"
                                          checked={
                                            addressData.isDeliveryTimeRestriction
                                          }
                                          onChange={(e) => {
                                            const { name, checked } = e.target;
                                            setAddressData((prevData) => {
                                              const updatedData = {
                                                ...prevData,
                                                [name]: checked,
                                              };
                                              if (
                                                name ===
                                                  'isDeliveryTimeRestriction' &&
                                                !checked
                                              ) {
                                                updatedData.deliveryTimeSlot =
                                                  '';
                                              }
                                              return updatedData;
                                            });
                                          }}
                                        />
                                      </div>
                                      <span className="fs-12">Yes</span>
                                    </div>
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>

                            {addressData.isDeliveryTimeRestriction && (
                              <Row>
                                <Col md={12}>
                                  <FormGroup className="mb-3">
                                    <Label className="fs-12">
                                      Preferred Delivery Time Slot
                                    </Label>
                                    <AvField
                                      name="deliveryTimeSlot"
                                      type="text"
                                      value={addressData.deliveryTimeSlot}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            )}

                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <Label
                                      htmlFor="isPermitRequired"
                                      className="fs-12 mb-0 me-2"
                                    >
                                      Do you require any permits to enter your
                                      premise?
                                    </Label>
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="fs-12">No</span>
                                      <div className="form-check form-switch m-0">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="isPermitRequired"
                                          name="isPermitRequired"
                                          checked={addressData.isPermitRequired}
                                          onChange={(e) => {
                                            const { name, checked } = e.target;
                                            setAddressData((prevData) => {
                                              const updatedData = {
                                                ...prevData,
                                                [name]: checked,
                                              };
                                              if (
                                                name === 'isPermitRequired' &&
                                                !checked
                                              ) {
                                                updatedData.permitRequiredComment =
                                                  '';
                                              }
                                              return updatedData;
                                            });
                                          }}
                                        />
                                      </div>
                                      <span className="fs-12">Yes</span>
                                    </div>
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>

                            {addressData.isPermitRequired && (
                              <Row>
                                <Col md={12}>
                                  <FormGroup className="mb-3">
                                    <Label
                                      htmlFor="permitRequiredComment"
                                      className="fs-12"
                                    >
                                      Permit Required Comment
                                    </Label>
                                    <AvField
                                      name="permitRequiredComment"
                                      type="text"
                                      placeholder="Enter your comment"
                                      value={addressData.permitRequiredComment}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            )}

                            <Row>
                              <Col md={12}>
                                <FormGroup className="mb-3">
                                  <Label className="fs-12">
                                    Any other delivery instructions
                                  </Label>
                                  <AvField
                                    name="otherInstructions"
                                    type="text"
                                    value={addressData.otherInstructions}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </>
                        )}



                        <div className="d-flex justify-content-end gap-2">
                          {!hideSubmit && (
                            source !== 'serviceOrder' ? (
                              <>
                                <Button
                                  color="light"
                                  className="fs-13"
                                  onClick={() => {
                                    setIsEnableMap(true);
                                    setIsAddressEdit(false);
                                  }}
                                >
                                  Back
                                </Button>

                                <Button
                                  color="secondary"
                                  className="fs-13"
                                  type="submit"
                                >
                                  Continue
                                </Button>
                              </>
                            ) : (
                              <Button
                                color="secondary"
                                className="fs-13"
                                type="submit"
                                disabled={isUpdatingLocation}
                              >
                                {isUpdatingLocation ? 'Submitting...' : 'Submit'}
                              </Button>
                            )
                          )}
                        </div>
                      </AvForm>
                    </div>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </>
      ) : (
        ''
      )}

    </>
  );
}

export default AddAddressComponent;
